import { c as _c } from "react/compiler-runtime";
import { useTranslation as useI18nTranslation } from 'react-i18next';
export const useTranslation = () => {
  const $ = _c(7);
  const {
    t,
    i18n
  } = useI18nTranslation();
  let t0;
  if ($[0] !== i18n) {
    t0 = lng => {
      i18n.changeLanguage(lng);
    };
    $[0] = i18n;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const changeLanguage = t0;
  const t1 = i18n.resolvedLanguage ?? i18n.language;
  let t2;
  if ($[2] !== changeLanguage || $[3] !== i18n.isInitialized || $[4] !== t || $[5] !== t1) {
    t2 = {
      changeLanguage,
      currentLanguage: t1,
      isReady: i18n.isInitialized,
      t
    };
    $[2] = changeLanguage;
    $[3] = i18n.isInitialized;
    $[4] = t;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};